exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".solution-title {\n  font-size: 14px !important;\n  font-weight: 600;\n  color: #5a2684;\n}\n\n.solutions-heading {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #5a2684;\n  margin-bottom: 1rem;\n}\n\n.solutions-grid-container {\n  background-color: #f5f5f5;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/SolutionsGrid/SolutionsGrid.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/SolutionsGrid/SolutionsGrid.css
// module chunks = 0